import React from 'react';
import { Flex } from '@amzn/storm-ui';
import { ManageAccountLink } from './styles';
import { useAccountDropdownContext } from './AccountDropdownProvider';
import { useAccountDropdownBundle } from 'src/providers/PantherLocalizationProvider';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';

export const IA2AccountDropdownFooterLinks: React.VFC = () => {
  const { currentEntityId } = useAccountDropdownContext();
  const bundle = useAccountDropdownBundle();

  const managerAccountDiscoveryLink = `/am/managerAccounts/list?entityId=${currentEntityId}&ref_=AAC_unav_discovery_account_dropdown`;

  return (
    <Flex
      data-ccx-e2e-id="account-dropdown-footer-links"
      direction="column"
      rowGap="xxsmall"
      paddingInlineStart="base"
      paddingInlineEnd="base"
      paddingBlockStart="xsmall"
      paddingBlockEnd="xsmall"
    >
      <ManageAccountLink
        href={`/accounts?entityId=${currentEntityId}&ref_=AAC_unav_manageaccounts`}
        data-ccx-e2e-id="aac-account-management"
        {...getTaktAttributes('manager-account-link', chromeComponents.HEADER)}
      >
        {bundle.getMessage('account-dropdown-manage-accounts-link-label')}
      </ManageAccountLink>
      <ManageAccountLink
        href={managerAccountDiscoveryLink}
        data-ccx-e2e-id="aac-master-account-discovery-link"
        {...getTaktAttributes(
          'ccx-master-account-discovery-link',
          chromeComponents.HEADER,
        )}
      >
        {bundle.getMessage('account-dropdown-create-manager-account-label')}
      </ManageAccountLink>
    </Flex>
  );
};
